import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { RebookingEndpoints } from '../api/constants';
import { setRebookIntention } from '../api/requests';
import { RebookingDecision } from '../../../utils/enum/RebookingDecision';

export const useSetKeepReleaseRoomIntention = () =>
    useMutation<void, AxiosError, { intention: RebookingDecision }>({
        mutationKey: [RebookingEndpoints.SetRebookIntention],
        mutationFn: async ({ intention }) => setRebookIntention(intention),
    });
